import type { ApprovalProposalDetail } from "@adpilot/shared";
import { IconShieldCheck } from "@tabler/icons-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReviewProposalDialog } from "@/components/approval/review-proposal-dialog";
import { Button } from "@/components/ui/button";

interface ApprovalDecisionControlsProps {
  proposal: ApprovalProposalDetail;
  onApplied: () => void;
}

export function ApprovalDecisionControls({ proposal, onApplied }: ApprovalDecisionControlsProps) {
  const { t } = useTranslation("approval");
  const [reviewOpen, setReviewOpen] = useState(false);
  if (proposal.reviewStatus !== "pending") return null;

  const pendingCount = proposal.actions.filter(
    ({ reviewStatus }) => reviewStatus === "pending",
  ).length;

  return (
    <div className="flex w-full flex-wrap items-center gap-2">
      <Button onClick={() => setReviewOpen(true)}>
        <IconShieldCheck data-icon="inline-start" />
        {t("controls.review", { count: pendingCount })}
      </Button>

      <ReviewProposalDialog
        proposalId={proposal.id}
        shopId={proposal.shopId}
        actions={proposal.actions}
        open={reviewOpen}
        onOpenChange={setReviewOpen}
        onApplied={onApplied}
      />
    </div>
  );
}
